<template>
    <v-dialog v-model="dialog" max-width="500" scrollable :fullscreen="$vuetify.breakpoint.mobile">
        <template v-slot:activator="{on}">
            <v-combobox multiple chips solo v-on="on"
                        class="hidden-sm-and-down"
                        style="position:absolute; top:10px; left:50px; right:50px;"
                        append-icon=""
                        v-model="shownPlantIds" :items="plants"
                        :menu-props="customMenuProps"
                        @focus="onClick">

                <template v-slot:selection="{item, index}">
                    <v-chip v-if="index < 5">
                        <v-icon :color="findPlant(item).color">mdi-map-marker</v-icon>
                        <span>{{findPlant(item).name}}</span>
                    </v-chip>
                    <span v-if="index === 5" class="grey--text caption">(+{{shownPlantIds.length - 5}} {{$t('key.others')}})</span>
                </template>
            </v-combobox>

            <v-btn fab dark large bottom left fixed color="grey" v-on="on" class="hidden-md-and-up" @click="onClick">
                <v-icon>mdi-filter</v-icon>
            </v-btn>
        </template>

        <v-card class="mt-sm-10">
            <v-card-title>
                <span>{{$t('key.mapSettings')}}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-scroll.self="onScroll">
                <br/>
                <v-list-item-title>
                    {{$t('key.mapFilter')}}
                    <span v-if="selectedPlantIds.length < plants.length">{{$t('key.mapFilterSelected', {'0': this.selectedPlantIds.length, '1': plants.length})}}</span>
                </v-list-item-title>
                <v-list>
                    <v-list-item-group multiple v-model="selectedPlantIds">
                        <template v-for="(plant) in plants">
                            <v-list-item :key="plant.uuid" :value="plant.uuid">
                                <template v-slot:default="{active}">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon :color="plant.color">mdi-map-marker</v-icon>
                                            <span>{{plant.name}}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-checkbox color="green" :input-value="active" :true-value="plant"></v-checkbox>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
                <br/>

                <v-list-item-title>{{$t('key.mapTypes')}}</v-list-item-title>
                <v-radio-group v-model="selectedMapType" @change="onMapTypeChange" row>
                    <v-radio v-for="(mapType, idx) in mapTypes" :key="idx" :label="$t('key.mapType' +mapType.text)" :value="mapType.value" ></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-btn block icon disabled :style="{visibility: showMore ? 'visible' : 'hidden'}"><v-icon x-large >mdi-menu-down</v-icon></v-btn>
            <v-divider></v-divider>
            <v-card-actions class="mx-auto">
                <div>
                <v-btn dark class="green lighten-1 ma-2" min-width="100px" @click="onApply">{{$t('app.ok')}}</v-btn>
                <v-btn class="ma-2" min-width="100px" @click="onCancel">{{$t('app.cancel')}}</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {MapTypes} from '../../_helpers';

    export default {
        name: 'MapToolbar',
        computed: {
            plants() {
                return this.$store.getters.plantList
            },
            mapTypes() {
                return MapTypes.list()
            },
            customMenuProps() {
                return {value: false} // hide default menu
            }
        },
        data: () => ({
            dialog: false, // dialog state - is it visible?

            shownPlantIds: [], // shown plants in combo-box
            selectedPlantIds: [], // selected plants in dialog

            selectedMapType: MapTypes.HYBRID.value,
            showMore: true,
        }),
        methods: {
            findPlant(uuid) {
                return this.plants.find(item => item.uuid === uuid)
            },
            onClick() {
                this.dialog = true

                // Preselect shown plants
                this.selectedPlantIds = this.shownPlantIds
            },
            onApply() {
                // Close dialog
                this.dialog = false

                // Sync selected with shown plants
                this.shownPlantIds = this.selectedPlantIds

                // Trigger change notification
                this.$emit('plants-change', this.shownPlantIds)
                this.$emit('map-type-change', this.selectedMapType)
            },
            onCancel() {
                // Close dialog
                this.dialog = false
            },
            onMapTypeChange(mapType) {
                this.selectedMapType = mapType
            },
            onScroll (e) {
                this.showMore = e.target.scrollHeight-e.target.offsetHeight-e.target.scrollTop > 10
            }
        },
        watch: {
            plants(newPlants/*, oldPlants*/) {
                this.shownPlantIds = newPlants.map(plant => plant.uuid) // pre-select plants
            }
        },
        mounted() {
            this.$store.dispatch('getPlants');
        }
    }
</script>

<style lang="scss">
    // empty
</style>
